import { useQuery } from '@tanstack/react-query';
import { GetUsersParams, advisoryService } from '../../../services';

export function useAdvisoriesUsers(params: GetUsersParams = {}) {
  return useQuery({
    queryKey: ['advisories-users', params],
    queryFn: async () => {
      const response = await advisoryService.getAdvisoriesUsers(params);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar usuários da assessorias'
        );
      }

      const apiData = response.data;
      const transformedPagination = {
        page: apiData.meta.pageNumber,
        limit: apiData.meta.pageSize,
        total: apiData.meta.total,
        totalPages: apiData.meta.totalPages,
      };

      return {
        users: apiData.data,
        pagination: transformedPagination,
      };
    },
    staleTime: 1000 * 60 * 5,
  });
}
